<div *ngIf="showBar" class="bar"
     [ngClass]="{'block-element' : blockType === videoState}"
     (mouseover)="changeCircleThumbVisibility(true)"
     (mouseleave)="changeCircleThumbVisibility(false)"
     (click)="clickBar($event)">
    <div class="bar__progress" [style.width.%]="width">
        <div class="circle-thumb"
             [ngClass]="{'block-element' : blockType === videoState,
             'circle-thumb-visible': isCircleThumbVisible,
             'circle-thumb-hidden': !isCircleThumbVisible}">
        </div>
    </div>
    <div class="shadow-div">
    </div>
</div>


